import { render, staticRenderFns } from "./OssUpload.vue?vue&type=template&id=43393688&scoped=true&"
import script from "./OssUpload.vue?vue&type=script&lang=js&"
export * from "./OssUpload.vue?vue&type=script&lang=js&"
import style0 from "./OssUpload.vue?vue&type=style&index=0&id=43393688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43393688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43393688')) {
      api.createRecord('43393688', component.options)
    } else {
      api.reload('43393688', component.options)
    }
    module.hot.accept("./OssUpload.vue?vue&type=template&id=43393688&scoped=true&", function () {
      api.rerender('43393688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/OssUpload.vue"
export default component.exports